import GlobalFooter from "@/patterns/global-footer/src";

export const Footer = () => {
    return (
        <div>
            <GlobalFooter />
        </div>
    );
};

Footer.displayName = "Footer";
